import { AdminRequest } from "./AdminRequest";
import { ClientUpdateHandlerRegistry } from "./ClientUpdateHandlerRegistry";
import { ClientUpdateRequestType } from "./ClientUpdateRequestType";
import { Collection } from "../Collection";
import { Logger } from "../logging/Logger";
import { LogManager } from "../logging/LogManager";

export class ClientUpdateRequest extends AdminRequest {
    private static log: Logger;
    updateType: ClientUpdateRequestType;
    addlInputs: Collection<any>;

    constructor(message: any) {
        super(message);
        this.updateType = message.updateType;
        this.addlInputs = message.addlInputs;
    }

    override handle(): void {
        const log = ClientUpdateRequest.getLog();
        log.debug("Updating client, type: %s", this.updateType);
        const handler = ClientUpdateHandlerRegistry.get().getObject(this.updateType);
        if (handler != null) {
            log.debug("Handling client update request of type %o with handler %o", this.updateType, handler);
            handler.handle(this.addlInputs);
        } else {
            log.debug("Ignoring client update request of type %o, no handler exists to process the request");
        }
    }

    private static getLog(): Logger {
        if (this.log == null) {
            this.log = LogManager.getLogger("core.client.ClientUpdateRequest");
        }
        return this.log;
    }
}
